import { socialLinks } from '../assets/siteData';
import { Button } from '../components/Button';
import { Section } from '../components/Section';
import { ConsultationWizard } from '../components/consultation/ConsultationWizard';

export function ContactPage() {
  return (
    <Section
      className="booking-page"
      eyebrow="Hire Me"
      title="Start a project, ask a question, or build something premium together"
      description="Fill out the consultation form below and we'll prepare a focused call. You can also reach out directly through any channel listed here."
    >
      <div className="contact-layout contact-layout--hire">
        <div className="contact-card glass-panel">
          <p className="eyebrow">Reach Out</p>
          <h2>Let's create something people trust instantly.</h2>
          <p>
            Share your idea for a product, website, course brand, robotics concept, or collaboration.
            Fill out the form to book a consultation, or reach out directly.
          </p>
          <div className="contact-links">
            {socialLinks.map((item) => (
              <a key={item.label} href={item.href} target="_blank" rel="noreferrer">
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </a>
            ))}
          </div>
          <Button href="https://wa.me/917078849475">WhatsApp</Button>
        </div>

        <div className="contact-wizard-wrap">
          <ConsultationWizard />
        </div>
      </div>
    </Section>
  );
}
